// extracted by mini-css-extract-plugin
module.exports = {"content":"SykmeldtSide_content__OADSd","innercontent":"SykmeldtSide_innercontent__cCyVf"};